<template>
  <div class="highlight-box p-1 align-self-center">
    <div class="d-flex flex-wrap align-items-center">
      <highlight-card
        class="p-2"
        v-for="card in cards"
        :key="card.id"
        @click="chooseCard(card.id, card.type)"
        :image="thumbnail(card)"
        :type="card.type"
        :desc="card.description"
      ></highlight-card>
      <button class="highlight-box-more mx-auto" @click="seeMore()">
        {{ moreBtn[lang] }}
      </button>
    </div>
  </div>
</template>

<script>
import HighlightCard from "@/components/HighlightCard/HighlightCard.vue";
export default {
  data() {
    return {
      moreBtn: {
        fr: 'Voir plus +',
        en: 'See more +',
        ar: '+ شاهدالمزيد',
      },
    };
  },
  components: {
    HighlightCard,
  },
  computed: {
    cards() {
      return this.$store.state.media.cards;
    },
    lang() {
      return this.$store.getters['lang/getCurrentLang'];
    },
  },
  methods: {
    chooseCard(id, type) {
      this.$store.commit("media/chooseSrc", {
        id,
        type,
      });
    },
    thumbnail(card) {
      if (card.type == "video") {
        let id = card.url.split("embed/");
        return `https://img.youtube.com/vi/${id[1]}/0.jpg`;
      } else {
        return card.url;
      }
    },
    seeMore() {
      this.$router.push({ name: "gallery" });
    },
  },
};
</script>

<style src="./HighlightBox.css" scoped></style>
